import * as dayjs from "dayjs";
import { PaymentInterval } from "../simulator/simulator";
import { convertToInterestFraction } from "../commons";

export interface IAdjustForGracePeriodParams {
    amount: number;
    loanDate: Date,
    dueDate: Date;
    interestRate: number;
    iof: number;
    paymentInterval: PaymentInterval;
}

export const adjustForGracePeriod = (request: IAdjustForGracePeriodParams): number => {
    const {
        amount, loanDate, dueDate, iof, interestRate, paymentInterval
    } = request;

    const interestFraction = convertToInterestFraction(interestRate, paymentInterval);
    const limitDateToAccrual = paymentInterval == PaymentInterval.Weekly
        ? dayjs(dueDate).subtract(1, 'week')
        : dayjs(dueDate).subtract(1, 'month')
    ;

    let adjustedAmount = amount + iof;
    let baseDate = dayjs(loanDate);

    while (baseDate < limitDateToAccrual) {
        if(paymentInterval == PaymentInterval.Weekly) {
            let dateToAccrual = baseDate.add(1, 'week');

            if(dateToAccrual > limitDateToAccrual) {
                dateToAccrual = limitDateToAccrual;
            }

            let gracePeriodInterest = adjustedAmount * (interestFraction / 7 * dateToAccrual.diff(baseDate, 'day'))

            adjustedAmount += gracePeriodInterest;
            baseDate = dateToAccrual;
        }
        else {
            const maxDifferenceInDays = baseDate.add(1, 'month').diff(baseDate, 'day');
            let dateToAccrual = baseDate.add(1, 'month').set('date', dueDate.getDate());
    
            if (dateToAccrual.diff(baseDate, 'day') > maxDifferenceInDays) {
                dateToAccrual = dateToAccrual.subtract(dateToAccrual.diff(baseDate, 'day') - maxDifferenceInDays, 'day');
            }
            if (dateToAccrual > limitDateToAccrual) {
                dateToAccrual = limitDateToAccrual;
            }
            let gracePeriodInterest = adjustedAmount * (interestFraction / 30 * dateToAccrual.diff(baseDate, 'day'));
    
            adjustedAmount += gracePeriodInterest;
            baseDate = dateToAccrual;
        }
    }

    return adjustedAmount;
}
